/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_Roles_TitleInputs */

const en_mk_sec_pg_roles_title = /** @type {(inputs: Mk_Sec_Pg_Roles_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who may do what`)
};

const id_mk_sec_pg_roles_title = /** @type {(inputs: Mk_Sec_Pg_Roles_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siapa boleh melakukan apa`)
};

/**
* | output |
* | --- |
* | "Who may do what" |
*
* @param {Mk_Sec_Pg_Roles_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_roles_title = /** @type {((inputs?: Mk_Sec_Pg_Roles_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_Roles_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_roles_title(inputs)
	return en_mk_sec_pg_roles_title(inputs)
});